import {BaseQueryOptions, BaseUseQueryResult, useBaseQuery} from "@bounce/shared/requests";
import {AxiosResponse} from "axios";
import {axiosConsumerAppInstance} from "~/api/ConsumerApiManager";
import {Questionnaire} from "./types";

type Variables = {
  accountId: string;
};

type Data = Questionnaire;

export const getQuestionnaire = async (variables: Variables): Promise<Data> => {
  if (!variables.accountId) {
    // @ts-ignore
    return;
  }
  const result = await axiosConsumerAppInstance.get<Data, AxiosResponse<Data>>(
    `/questionnaire/${variables.accountId}`
  );

  return result.data;
};

export const useGetQuestionnaireQuery = (
  variables: Variables,
  options?: BaseQueryOptions<Data, Variables>
): BaseUseQueryResult<Data> => {
  return useBaseQuery<Data, Variables>(
    ["account", variables.accountId, "questionnaire"],
    getQuestionnaire,
    variables,
    {staleTime: Infinity, ...options}
  );
};
